import { sessionPrefix } from "./helpers";

export const adminRemindersPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/admin/reminders`;
export const newAdminReminderPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/admin/reminders/new`;
export const editAdminReminderPath = (session: LightSessionInterface, reminder: ReminderRef) =>
  `${sessionPrefix(session)}/admin/reminders/${reminder.id}/edit`;

export const reminderNotificationsPath = (session: LightSessionInterface) =>
  `${sessionPrefix(session)}/reminder-notifications`;
